var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-border-radius"},[_vm._t("prepend"),_vm._l((_vm.presets),function(preset,index){return _c('btn-border-radius',{key:`radius-${index}`,attrs:{"preset":preset},model:{value:(_vm.currentBorderRadius),callback:function ($$v) {_vm.currentBorderRadius=$$v},expression:"currentBorderRadius"}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }